<app-template>
  <ng-container *ngIf="activePanel() === 'Dashboard'; else statisticTpl">
    <div class="dashboard-container">
      <!-- Dashboard Header -->
      <mat-card class="dashboard-header-card mb-4" appearance="outlined">
        <mat-card-content class="p-4">
          <div class="row align-items-center g-3">
            <div class="col-12 col-md-7 col-lg-8">
              <div class="d-flex align-items-center mb-1 gap-2">
                <mat-icon class="welcome-icon">waving_hand</mat-icon>
                <h2 class="dashboard-title mb-0">Welcome, {{ accountName() }}</h2>
              </div>
              <p class="text-muted mb-2 ps-1">Manage your society operations from here</p>
              <div class="d-flex align-items-center mt-2 ps-1">
                <span class="role-chip">
                  <mat-icon class="role-chip-icon">account_circle</mat-icon>
                  <span class="role-chip-text">{{ roleName() || 'Member' }}</span>
                </span>
              </div>
            </div>
            <div class="col-12 col-md-5 col-lg-4 text-md-end">
              <div class="d-flex align-items-center gap-2 justify-content-end justify-content-md-end">
                <button
                  type="button"
                  class="raise-request-icon-btn"
                  (click)="raiseRequests()"
                  matTooltip="Raise Request"
                  matTooltipPosition="below">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="raise-request-svg-icon">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
                    <line x1="12" y1="11" x2="12" y2="17"/>
                    <line x1="9" y1="14" x2="15" y2="14"/>
                  </svg>
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [class.active]="isRequestDashboardActive()"
                  (click)="selectPanel('Request Dashboard')"
                  class="request-dashboard-btn">
                  <mat-icon>dashboard</mat-icon>
                  <span class="ms-2">Request Dashboard</span>
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Loading State -->
      <div *ngIf="isLoading()" class="d-flex justify-content-center align-items-center py-5">
        <mat-spinner diameter="50"></mat-spinner>
        <span class="ms-3 text-muted">Loading dashboard...</span>
      </div>

      <!-- Error State -->
      <div *ngIf="error() && !isLoading()" class="mb-4">
        <mat-card appearance="outlined" class="border-warning">
          <mat-card-content class="p-3">
            <div class="d-flex align-items-center">
              <mat-icon color="warn" class="me-2">error_outline</mat-icon>
              <span class="text-warning">{{ error() }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Dashboard Cards Grid -->
      <div class="row g-3" *ngIf="!isLoading()">
        <div 
          class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2" 
          *ngFor="let item of dashboardItems; trackBy: trackByItemId">
          <mat-card 
            class="dashboard-card h-100" 
            appearance="outlined"
            (click)="navigateToRoute(item.route)">
            <mat-card-content class="text-center p-3">
                <div class="icon-wrapper mb-2">
                  <mat-icon class="dashboard-icon">{{ item.icon }}</mat-icon>
                </div>
                <h5 class="card-title mb-1 fw-semibold">{{ item.title }}</h5>
                <p class="text-muted small mb-0">{{ item.description }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #statisticTpl>
    <app-admin-dashboard></app-admin-dashboard>
  </ng-template>
</app-template>
